import React from 'react'
import { css } from '@emotion/core'
import { Separator } from '@fs/zion-ui'
import { H4 } from './type/type'
import RichTextDisplayer from './RichTextDisplayer'

const smallHeadingCss = css`
  font-size: 20px;
  font-weight: 700;
  line-height: 28px;
  margin: 0;
  padding: 0;
`

const buttonWrapperCss = css`
  flex-grow: 2;
  max-width: fit-content;
`

export default function SectionHeader({ heading, description, headerUppercase, small, button }) {
  const sectionHeaderCss = css`
    display: flex;
    justify-content: space-between;
    margin-bottom: 4px;
    ${headerUppercase ? 'text-transform: uppercase;' : ''}
    & > h2 {
      font-weight: 700;
    }
  `

  return (
    <div>
      <div css={sectionHeaderCss}>
        {small ? <h2 css={smallHeadingCss}>{heading}</h2> : <H4 as="h2">{heading}</H4>}
        {/* hide open-close button from the screen readers since it is open by default and that is better */}
        <div css={buttonWrapperCss} aria-hidden>
          {button}
        </div>
      </div>
      {description && <RichTextDisplayer richText={description} />}
      <Separator size="sm" />
    </div>
  )
}
